import { constants, typographyStyles } from "@newsela/angelou";

const greyDark = constants.colors.ui.neutral[600];
const greyLight = constants.colors.ui.neutral[100];

const { heading4Obj } = typographyStyles;

export const rootCss = {
  // Temporary hardcoded height until we change this section to use a
  // an Angelou accordion component.
  height: "440px",
  width: "100%",
};

export const headerCss = {
  display: "flex",
  alignItems: "center",
  borderBottom: `1px solid ${greyLight}`,
};

export const iconCss = {
  marginLeft: "24px",
};

export const headingCss = {
  ...heading4Obj,
  paddingLeft: "8px",
  color: greyDark,
};
